/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  isLoading: false,
  isLoaded: false,
  loading: false,
  loaded: false,
  loadingApi: false,
  loadedApi: true,
  successResponse: null,
  deleteSuccessResponse: null,
  resendSuccessResponse: null,
  userUpdateSuccessResponse: null,
  currentUser: {},
  togglingStatus: false,
  toggleStatusResponse: null,
  toggleStatusError: null,
  errorResponse: null,
  currentUserDetails: {},
  currentUserDetailsLoading: false,
  currentUserDetailsLoaded: true,
  roleList: {},
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USERS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_USERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ...action.payload,
      };
    }
    case types.FETCH_USERS_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_USER: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        currentUser: action.payload,
      };
    }
    case types.FETCH_A_USER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_USER_DETAILS: {
      return {
        ...state,
        currentUserDetailsLoading: true,
        currentUserDetailsLoaded: false,
      };
    }
    case types.FETCH_A_USER_DETAILS_SUCCESS: {
      return {
        ...state,
        currentUserDetailsLoading: false,
        currentUserDetailsLoaded: true,
        currentUserDetails: action.payload,
      };
    }
    case types.FETCH_A_USER_DETAILS_FAILED: {
      return {
        ...state,
        currentUserDetailsLoading: false,
        currentUserDetailsLoaded: true,
        error: action.payload,
      };
    }
    case types.REMOVE_USER: {
      return {
        ...state,
        currentUser: {},
        successResponse: null,
      };
    }
    case types.CREATE_USER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        errorResponse: null,
        successResponse: null,
      };
    }
    case types.CREATE_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.CREATE_USER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.UPDATE_USER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        errorResponse: null,
        successResponse: null,
      };
    }
    case types.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.UPDATE_USER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.ENABLE_USER: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_USER_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_USER_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.DISABLE_USER: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_USER_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_USER_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.UPDATE_USER_STATUS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        errorResponse: null,
        successResponse: null,
      };
    }
    case types.UPDATE_USER_STATUS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        userUpdateSuccessResponse: action.payload,
      };
    }
    case types.UPDATE_USER_STATUS_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.RESEND_INVITE: {
      return {
        ...state,
        loadingApi: true,
        loadedApi: false,
        errorResponse: null,
        successResponse: null,
      };
    }
    case types.RESEND_INVITE_SUCCESS: {
      return {
        ...state,
        loadingApi: false,
        loadedApi: true,
        resendSuccessResponse: action.payload,
      };
    }
    case types.RESEND_INVITE_FAILED: {
      return {
        ...state,
        loadingApi: false,
        loadedApi: true,
        errorResponse: action.payload,
      };
    }
    case types.DELETE_USER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        errorResponse: null,
        successResponse: null,
      };
    }
    case types.DELETE_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        deleteSuccessResponse: action.payload,
      };
    }
    case types.DELETE_USER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.CLEAR_USER: {
      return {
        ...state,
        successResponse: null,
        errorResponse: null,
        currentUserDetails: {},
        deleteSuccessResponse: null,
      };
    }
    case types.CLEAR_USER_LIST: {
      return {
        ...state,
        list: [],
        isLoading: false,
        isLoaded: false,
        successResponse: null,
        errorResponse: null,
        resendSuccessResponse: null,
        currentUserDetails: {},
        userUpdateSuccessResponse: null,
        deleteSuccessResponse: null,
      };
    }
    case types.CLEAR_RESENT_INVITE: {
      return {
        ...state,
        resendSuccessResponse: null,
        errorResponse: null,
      };
    }
    case types.FETCH_USER_ROLES: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_USER_ROLES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        roleList: action.payload,
      };
    }
    case types.FETCH_USER_ROLES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
